import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import history from "../../utils/history";
import {
  setImported,
  setProject,
  setCurrentWindow
} from "../../store/actions/project";
import { setSolution } from "../../store/actions/solution";
import { setLoadingImport } from "../../store/actions/loading";
import API from "../../utils/axios";
import axios from "axios";
// import XLSX from "xlsx";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles, IconButton } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import XlsxExampleFile from "../data/import/sample-stops.xlsx";
import DataTable from "./DataTable";
import DragAndDrop from "./DragAndDrop";
import ExampleTable from "./ExampleTable";
import BackIcon from "@material-ui/icons/ArrowBack";
import xlsxIcon from "../../assets/images/icons/xlsx-icon.svg";
import LoadingCircle from "../common/LoadingCircle";
import { servicesExample } from "../data/import/examples";
import {
  remCalc,
  numberWithCommas,
  exportToXlsx,
  getTimeStr,
  convertTimeToHoursAndMins
} from "../../utils/helpers";
import TextField from "@material-ui/core/TextField";
import { Trans } from "react-i18next";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Chip from "@material-ui/core/Chip";
import { setInfoDialog } from "../../store/actions/common";
import { useSnackbar } from "notistack";
import { setExtendableType } from "../../store/actions/edit";

import { setUploadStopsOpen } from "../../store/actions/account";
import { useImportStyles } from "./commonStyles";
import { fields } from "../data/import/fields";
import { headerRow, MANUAL_GET_PROJECT } from "../data/constants";
import mixpanelWrapper from "../../utils/mixpanel";
import { format } from "date-fns";

const useStyles = makeStyles(theme => ({
  manualInput: {
    boxSizing: "border-box",
    margin: 0,
    "& .MuiOutlinedInput-root": {
      height: remCalc(36),
      "&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
        border: "2px solid #DDD"
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #DDD"
    }
  },
  label: {
    color: "#808080",
    fontSize: "0.875rem",
    paddingLeft: theme.spacing(0.25)
  },
  manualButton: {
    marginLeft: theme.spacing(2),
    boxShadow: "none"
  },
  downloadBtn: {
    textDecoration: "none"
  },
  title: {
    fontSize: "1.25rem",
    lineHeight: "1.4375rem",
    fontWeight: 500
  },
  panelSummary: {
    "& .MuiExpansionPanelSummary-expandIcon": {
      alignSelf: "start"
    }
  },
  backButton: {
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(2)
  }
}));

function Import({
  setImported,
  validServices,
  invalidServices,
  loadingImport,
  project,
  setProject,
  setInfoDialog,
  plan,
  setCurrentWindow,
  setSolution,
  setLoadingImport,
  setUploadStopsOpen
}) {
  const [manualId, setManualId] = useState("");

  const classes = { ...useImportStyles(), ...useStyles() };

  const [invalidRowsData, setInvalidRowsData] = useState(null);
  const [loadingValidation, setLoadingValidation] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const validatedData = useRef({});
  const importBody = useRef();
  const cancelUpload = useRef(null);

  const handleFetch = ({ body, file, extension, blank }) => {
    const CancelToken = axios.CancelToken;

    if (blank) {
      enqueueSnackbar("The uploaded file is blank.");
      setLoadingValidation(false);
      return;
    }

    let stops = file
      ? []
      : body.filter(obj => Object.keys(obj).filter(el => obj[el]).length);

    // Check limitations
    if (!plan.cap_rows_per_upload || stops.length > plan.cap_rows_per_upload) {
      setInfoDialog({
        visible: true,
        title: "Operation not possible",
        body: `The maximum number of rows per upload is ${numberWithCommas(
          plan.cap_rows_per_upload || 0
        )}.`
      });
      setLoadingValidation(false);
      setButtonVisible(false);
      return;
    }

    const handleValidation = res => {
      validatedData.current = res.data;
      setImported(res.data.valid, res.data.invalid, "stops");
      importBody.current.scrollTop = importBody.current.scrollHeight;
      if (res.data.invalid.length) {
        const invalidRows = [
          headerRow,
          ...res.data.invalid.map(rowData => {
            const row = rowData[0];
            return [
              row.type,
              row.information ? row.information.name : null,
              row.information ? row.information.street : null,
              row.information ? row.information.city : null,
              row.information ? row.information.zipcode : null,
              row.information ? row.information.country : null,
              row.address ? row.address.lat : null,
              row.address ? row.address.lng : null,
              row.duration,
              row.time_windows
                ? getTimeStr(row.time_windows[0].earliest)
                : null,
              row.time_windows ? getTimeStr(row.time_windows[0].latest) : null,
              row.information ? row.information.email : null,
              row.information ? row.information.recipient_phone : null,
              row.priority === 1 ? "Yes" : null,
              row.requirements && row.requirements.signature ? "Yes" : null,

              row.requirements && row.requirements.age_verification
                ? "Yes"
                : null,

              row.requirements && row.requirements.picture ? "Yes" : null,
              row.information ? row.information.notes : null,

              row.quantity,
              row.weight,
              row.volume,
              row.tags
                ?.filter(tag => tag.type === "VEHICLE")
                .map(el => el.name)
                .join("; "),
              row.tags
                ?.filter(tag => tag.type === "DRIVER")
                .map(el => el.name)
                .join("; "),
              row.units && row.units[0] ? row.units[0].name : null,
              row.units && row.units[0] ? row.units[0].note : null,
              row.tracking ? row.tracking.id : null
            ];
          })
        ];

        setInvalidRowsData(invalidRows);
      }
    };

    if (file) {
      console.log(body, file);
      API.post(
        `/v1/projects/${project.id}/tasks/mapping?type=${extension}`,
        file,
        {
          headers: {
            "Content-Type": "application/json"
          },
          cancelToken: new CancelToken(
            cancel => (cancelUpload.current = cancel)
          )
        }
      )
        .then(handleValidation)
        .catch(err => {
          console.log(err);
          enqueueSnackbar("Something went wrong while importing stops.");
        })
        .finally(() => {
          setLoadingValidation(false);
          setButtonVisible(false);
        });
      return;
    } else {
      stops = stops.map((el, i) => {
        const trimmedValues = Object.fromEntries(
          Object.entries(el).map(([key, value]) =>
            typeof value === "string" ? [key, value.trim()] : [key, value]
          )
        );

        return {
          row: String(i + 2),
          ...trimmedValues,
          long: isNaN(el.long || el.lng) ? null : el.long || el.lng,
          lat: isNaN(el.lat) ? null : el.lat,
          from: el.from
            ? isNaN(Date.parse(el.from))
              ? convertTimeToHoursAndMins(el.from)
              : format(new Date(el.from), "HH:mm")
            : el.from,
          to: el.to
            ? isNaN(Date.parse(el.to))
              ? convertTimeToHoursAndMins(el.to)
              : format(new Date(el.to), "HH:mm")
            : el.to,
          driver_tags: el.driver_tags
            ? el.driver_tags
                .split(";")
                .filter(tag => tag)
                .map(tag => tag.trim())
            : null,
          vehicle_tags: el.vehicle_tags
            ? el.vehicle_tags
                .split(";")
                .filter(tag => tag)
                .map(tag => tag.trim())
            : null,
          notes: el.delivery_note || el.notes,
          load: el.unit_count || el.load,
          weight: el.unit_weight || el.weight,
          volume: el.unit_volume || el.volume,
          lng: undefined
        };
      });

      body = {
        stops
      };

      API.post(`/v1/projects/${project.id}/services/validation`, body, {
        cancelToken: new CancelToken(cancel => (cancelUpload.current = cancel))
      })
        .then(res => {
          handleValidation(res);
          // TO2DO: maybe for future show wrong fields in red
          // testing the delete row functionality
          // let workbook = rawContent;
          // const firstWorksheet = workbook.Sheets[workbook.SheetNames[0]];
          // update_sheet_range(firstWorksheet);
          // res.data.valid.map(row => {
          //   delete_row(firstWorksheet, row.row_in_service_batch_upload - 1);
          // });
          // // var wb = XLSX.utils.book_new();
          // // XLSX.utils.book_append_sheet(wb, worksheet, "WorksheetName");
          // XLSX.writeFile(workbook, "failed_stops.xlsx");
          // console.log(rawContent);
        })
        .catch(error => {
          console.dir(error);
          if (error && error.data && error.data.status === 400) {
            setInfoDialog({
              visible: true,
              title: "Please upgrade your plan",

              body: error.data.message
            });
          } else if (axios.isCancel(error)) {
            enqueueSnackbar(error.message);
          } else {
            enqueueSnackbar("Something went wrong while importing stops.");
          }
        })
        .finally(() => {
          setLoadingValidation(false);
          setButtonVisible(false);
        });
    }
  };

  const handleUpload = () => {
    setLoadingImport(true);
    API.post(`/v1/projects/${project.id}/services/add`, validatedData.current)
      .then(res => {
        mixpanelWrapper.track("Stop Add", {
          Uploaded: true
        });
        setProject(res.data);
        setUploadStopsOpen(false);
        history.push(`/${sessionStorage.currentProject || ""}`);
      })
      .catch(err => {
        console.dir(err);
        enqueueSnackbar("Something went wrong while importing stops.");
      })
      .finally(() => {
        setLoadingImport(false);
      });
  };

  const handleCancelUpload = () => {
    if (cancelUpload.current) {
      cancelUpload.current("You have canceled the file upload");
    }
  };

  useEffect(() => {
    return () => setImported([], []);
  }, [setImported]);

  const handleManualSubmit = e => {
    e.preventDefault();
    setLoadingImport(true);
    API.get(`/v1/solutions/${manualId}/aws`)
      .then(res => {
        setSolution({
          ...res.data,
          showAll: true,
          id: project.status === "created" ? project.id : res.data.id
        });
        setLoadingImport(false);
        setUploadStopsOpen(false);
        setCurrentWindow("Optimized");
        history.push(`/${project.id}`);
      })
      .catch(error => console.log(error));
  };

  const servicesUploaded = validServices.length + invalidServices.length > 0;

  return (
    <div className={classes.root}>
      {/* Loading */}
      {(loadingValidation || loadingImport) && (
        <LoadingCircle
          drawerOpen={true}
          style={{ top: loadingValidation ? 80 : 0 }}
          blur={loadingValidation}
          cancel={buttonVisible}
          handleCancelUpload={handleCancelUpload}
        />
      )}

      {/* Header */}
      <Box className={classes.header} display="flex" alignItems="center" px={3}>
        <Box
          component={IconButton}
          onClick={e => {
            e.preventDefault();
            buttonVisible && handleCancelUpload();
            setUploadStopsOpen(false);
            history.replace(`/${project.id}`);
          }}
          data-cy="stops-closeUpload"
          className={classes.backButton}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            <BackIcon />
          </Box>
        </Box>

        <Typography variant="h5" className={classes.title}>
          <Trans i18nKey="uploadStops">Import stops</Trans>
        </Typography>
      </Box>

      <Box
        className={classes.body}
        ref={importBody}
        pt={servicesUploaded ? 3 : 4}
        pb={5}
      >
        {/* Load solution by id */}
        
        {MANUAL_GET_PROJECT && process.env.REACT_APP_ENVIRONMENT !== "prod" && (
          <Box
            component="form"
            onSubmit={handleManualSubmit}
            display="flex"
            alignItems="center"
            mt={1}
            px={3}
            pb={2.5}
          >
            <TextField
              label="Load by solution id"
              margin="dense"
              variant="outlined"
              value={manualId}
              onChange={e => setManualId(e.target.value)}
              className={classes.manualInput}
              fullWidth
              required
              InputLabelProps={{
                classes: {
                  root: classes.label
                }
              }}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.manualButton}
            >
              Load
            </Button>
          </Box>
        )}
        {!servicesUploaded && (
          <>
            <Box px={3} pb={2}>
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                Upload multiple stops from a file
              </Typography>

              <Typography variant="body2" style={{ color: "#7D7E82" }}>
                Supported file formats: .xls, .xlsx, .csv
              </Typography>
            </Box>
            {/* Body */}
            <DragAndDrop
              type="stops"
              handleFetch={handleFetch}
              isUploadingStops={true}
              setButtonVisible={setButtonVisible}
              setLoadingImportLeft={setLoadingValidation}
            />
            <Box px={3} mt={2} className={classes.section}>
              <Box mb={3}>
                <Typography
                  color="secondary"
                  variant="body2"
                  style={{ fontWeight: 500 }}
                >
                  <Trans i18nKey="templateFiles">Template file</Trans>
                </Typography>

                <Box display="flex" alignItems="center" mt={1}>
                  <Box
                    component="a"
                    display="flex"
                    alignItems="flex-end"
                    color={"#1329FE"}
                    data-cy="stopsTemplate"
                    href={XlsxExampleFile}
                    download
                    style={{ textDecoration: "none" }}
                    mr={2}
                  >
                    <Box component="img" src={xlsxIcon} alt="XLSX" mr={0.5} />
                    .XLSX file
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box pt={1} pb={4} px={3} mt={1.25} className={classes.section}>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon data-cy="driver-expandColumns" />}
                  className={classes.panelSummary}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box>
                    <Box component="p" my={1.25} fontWeight="fontWeightMedium">
                      Columns
                    </Box>

                    <Typography variant="body2">
                      Columns should be in the correct order and fields marked
                      in * are required (in case lat and long are not defined).
                    </Typography>
                  </Box>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                  <Box display="flex" flexWrap="wrap" pt={1}>
                    {fields.map((el, i) => (
                      <Chip
                        key={i}
                        label={`${el.name}${el.required ? "*" : ""}`}
                        className={clsx(classes.chip, {
                          [classes.chipDark]: el.required
                        })}
                      />
                    ))}
                  </Box>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Box>
            <Box pt={1} pb={2} px={3} className={classes.section}>
              <Box component="p" fontWeight="fontWeightMedium">
                Example
              </Box>

              <Box
                mt={3}
                mb={1}
                p={1}
                style={{
                  overflow: "auto",
                  backgroundColor: "#F7F7F7",
                  borderRadius: 4
                }}
              >
                <ExampleTable tableData={servicesExample} />
              </Box>
            </Box>
          </>
        )}

        {servicesUploaded && (
          <Box px={3}>
            {validServices.length ? (
              <>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 500, marginBottom: 16 }}
                >
                  Valid stops ({validServices.length})
                </Typography>
                <Box
                  style={{
                    overflow: "auto",
                    borderRadius: 4,
                    border: "1px dashed #F0F0F0"
                  }}
                  p={1}
                  mb={3}
                >
                  <DataTable tableData={validServices} validRows services />
                </Box>
              </>
            ) : null}

            {invalidServices.length ? (
              <>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 500, marginBottom: 16 }}
                >
                  Invalid stops ({invalidServices.length})
                </Typography>
                <Box
                  style={{
                    overflow: "auto",
                    borderRadius: 4,
                    border: "1px dashed #F0F0F0"
                  }}
                  py={1.75}
                  px={1}
                  mb={2}
                >
                  <DataTable
                    tableData={invalidServices.map(el => el[0])}
                    invalidRows
                    services
                  />
                </Box>
                <Typography variant="body2" style={{ marginTop: 8 }}>
                  We've separated invalid stops into their own spreadsheet.
                  Please download below, fix the errors then re-upload it, to
                  add them to your project.
                </Typography>

                {invalidRowsData && (
                  <Box mb={2}>
                    <Button
                      color="primary"
                      style={{
                        textDecoration: "none",
                        marginTop: 4,
                        fontWeight: "normal",
                        marginLeft: -8,
                        fontSize: "13px"
                      }}
                      onClick={() => {
                        exportToXlsx("failed_stops.xlsx", invalidRowsData);
                      }}
                    >
                      <Box component="img" src={xlsxIcon} alt="XLSX" mr={0.5} />{" "}
                      Download failed stops (.xlsx)
                    </Button>
                  </Box>
                )}
              </>
            ) : null}

            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              my={3}
            >
              <Button
                color="primary"
                component="button"
                onClick={() => setImported([], [])}
                style={{ marginRight: 8 }}
                className={classes.btn}
              >
                Cancel
              </Button>

              <Button
                color="primary"
                variant="contained"
                component="button"
                disableElevation
                onClick={handleUpload}
                className={classes.btn}
                disabled={!validServices.length && invalidServices.length}
                id="uploadStops-submitButton"
              >
                Done
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    imported: state.common.imported,
    validServices:
      state.project.importedData.type === "stops"
        ? state.project.importedData.valid
        : [],
    invalidServices:
      state.project.importedData.type === "stops"
        ? state.project.importedData.invalid
        : [],
    loadingImport: state.loading.importPage,
    project: state.project,
    plan:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation.plan) ||
      {}
  };
}

export default connect(mapStateToProps, {
  setImported,
  setProject,
  setLoadingImport,
  setCurrentWindow,
  setSolution,
  setUploadStopsOpen,
  setExtendableType,
  setInfoDialog
})(Import);
